module.exports = __webpack_public_path__ + "img/luxury-rental-vehicle@2x.fa08d9b8.jpg";